import React from "react";

const CoursePill = ({ course }) => {
  return (
    <>
      <p
        className={`min-h-[32px] px-2 py-1 
      ${
        course === "UI/UX Design"
          ? "bg-[#EFEFEF] text-[#333]"
          : course === "Branding"
          ? "bg-[#F8D21033] text-[#796500]"
          : course === "UX Research"
          ? "bg-[#F8D21033] text-[#796500] "
          : "bg-[#4AF81033] text-[#0F3B00]"
      } text-[10px] leading-[24px] rounded-[100px]`}
      >
        {course}
      </p>
    </>
  );
};

export default CoursePill;
